// API Configuration
// Determine API URL based on environment
function getApiUrl() {
  // If running on production domain, use relative URL (same origin)
  if (window.location.hostname === 'joeymrobinson.com' ||
      window.location.hostname === 'www.joeymrobinson.com') {
    return ''; // Empty string means relative URLs like /api/auth/login
  }

  // Development: use localhost backend
  return process.env.REACT_APP_API_URL?.replace(/\/api$/, '') || 'http://localhost:3001';
}

export const API_URL = getApiUrl();
